import { FC, useMemo } from 'react';
import Card from 'app/modules/analytics/components/shared/Card';
import ReportContentPostTable from './ReportContentPostTable';
import type { ContentPost } from 'api/new-analytics/types';
import type { MetricColumnDef } from 'app/modules/analytics/modules/content/utils/contentTableColumns';
import { mapContentPostToRow } from 'app/modules/analytics/modules/content/utils/mapContentPostToRow';
import { applyContentTableHighlights } from 'app/modules/analytics/modules/content/utils/applyContentTableHighlights';

interface Props {
  title: string;
  columns: MetricColumnDef[];
  posts: ContentPost[];
  isLoading?: boolean;
}

const ReportContentPostTableCard: FC<Props> = ({
  title,
  columns,
  posts,
  isLoading = false,
}) => {
  const rows = useMemo(() => {
    const mapped = posts.map(mapContentPostToRow);
    return applyContentTableHighlights(mapped, columns);
  }, [columns, posts]);

  return (
    <Card>
      <ReportContentPostTable
        title={title}
        columns={columns}
        rows={rows}
        isLoading={isLoading}
      />
    </Card>
  );
};

export default ReportContentPostTableCard;
